import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";
import PPTToPDFUploadView from "./PPTToPDFUploadView";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";

function PPTToPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PPT To PDF Converter Online Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/ppt_to_pdf", title: "Convert PPT To PDF Online" },
    data2: { link: "/ppt_to_pdf", title: "Convert Powerpoint To PDF Free" },
    data3: { link: "/ppt_to_pdf", title: "Office Slides To PDF Converter" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PPT to PDF online instantly. Turn PowerPoint presentations into high-quality PDFs quickly with our fast and secure PPT to PDF tool."
      ></meta>
      <meta
        name="keywords"
        content="ppt to pdf, convert ppt to pdf, powerpoint to pdf, ppt to pdf online, pptx to pdf, online ppt to pdf converter, convert presentation to pdf, ppt to pdf converter, powerpoint ppt to pdf, ppt file to pdf, ppt slides to pdf, ppt to pdf fast, ppt to pdf secure, powerpoint to pdf online, ppt document to pdf"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload PPT View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {/* Runpod datauri size limit = 9.9mb */}
        {showEditFileScreen ? (
          <PPTToPDFUploadView
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            allowedFileExtensions={["pptx", "ppt"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{
              "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                [".pptx"],
              "application/mspowerpoint": [".ppt"],
              "application/powerpoint": [".ppt"],
              "application/x-mspowerpoint": [".ppt"],
            }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our PPT to PDF online website is a fast, secure, and easy to use solution for converting PowerPoint presentations into high quality PDF documents. Designed for speed and accuracy, this PowerPoint to PDF converter online supports PPT and PPTX files while preserving original slide layouts, fonts, images, charts, and overall formatting. Whether you are a student submitting assignments, a teacher sharing lecture slides, or a professional preparing business reports, this convert PPT to PDF online tool ensures your presentations look professional and consistent on every device. With a simple upload and convert process, users can transform PowerPoint files into universally compatible PDFs in just a few clicks. Our PPT to PDF converter online works directly in your browser, eliminating the need for complex software installations or technical expertise. All conversions are handled with strong security measures, ensuring your files remain private and are automatically removed after processing. PDF output files are optimized for easy sharing, printing, and long term storage, making them ideal for emails, presentations, documentation, and official submissions. If you’re looking for a reliable, high performance PowerPoint to PDF online converter that delivers accurate results without quality loss, this website provides a seamless document conversion experience you can trust." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="PPT To PDF Converter"
          why_use={[
            {
              title: "Universal File Compatibility",
              description:
                "Using a PPT to PDF online converter ensures your PowerPoint files can be opened on any device and operating system without formatting issues. Converting PPT to PDF creates universally accessible documents that look consistent across all platforms.",
            },

            {
              title: "Preserves Original Formatting",
              description:
                "When you convert PPT to PDF online, all slide layouts, fonts, images, charts, and colors remain unchanged. Our reliable PowerPoint to PDF converter prevents formatting loss during sharing or viewing.",
            },

            {
              title: "Easy Sharing and Distribution",
              description:
                "PDF files are smaller and easier to share through email, messaging apps, and cloud platforms. Our PPT to PDF online website helps you distribute presentations quickly and professionally.",
            },

            {
              title: "Enhanced Security and Read Only Access",
              description:
                "Converting PowerPoint to PDF helps protect your content from unauthorized edits. This secure PPT to PDF online tool allows safe sharing of important presentations and documents.",
            },

            {
              title: "Offline Conversion for Data Privacy",
              description:
                "This online PPT to PDF converter processes files directly on your device without uploading them to servers. This ensures complete privacy when converting sensitive PowerPoint presentations.",
            },

            {
              title: "Professional Printing Output",
              description:
                "PDF is the preferred format for printing presentations. Using a PowerPoint to PDF online converter guarantees high quality, print ready documents with accurate page sizing.",
            },

            {
              title: "No Software Installation Required",
              description:
                "This browse based PPT to PDF online tool eliminates the need for installing heavy software. You can convert PowerPoint slides to PDF instantly with minimal effort.",
            },

            {
              title: "Faster Workflow and Productivity",
              description:
                "Our fast PPT to PDF converter online saves time by allowing quick and accurate conversions, helping students, teachers, and professionals improve productivity.",
            },

            {
              title: "Ideal for Business and Academic Use",
              description:
                "Our PowerPoint to PDF online tool is perfect for business reports, presentations, assignments, and lecture slides, ensuring a professional and consistent document format.",
            },
          ]}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default PPTToPDFMain;
